<template>
  <div class="w-screen flex flex-col justify-start px-20 py-20 bg-zinc-900">
    <div class="flex  xl:self-start self-center justify-center"> 
      <p class="inline-block xl:text-left text-center text-4xl font-extrabold mini-sunset mt-2 px-2">evala</p>
    </div>
      <p class="text-xs text-gray-200 xl:text-left text-center pt-1"> © 2022 evala.io</p> 
  </div>
</template>

<script>
export default {
    name: "Footer"
}
</script>

<style lang="scss">
.mini-sunset {
	background: linear-gradient(-45deg, #811D41, #983275, #FD2F24, #FF6F01, #FED800);
	background-size: 300%;
	letter-spacing: -1px;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
}
</style>